/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Ai_Brief_LabelInputs */

const cs_templates_ai_brief_label = /** @type {(inputs: Templates_Ai_Brief_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brief / požadavek klienta`)
};

const en_templates_ai_brief_label = /** @type {(inputs: Templates_Ai_Brief_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brief / client demand`)
};

/**
* | output |
* | --- |
* | "Brief / client demand" |
*
* @param {Templates_Ai_Brief_LabelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_ai_brief_label = /** @type {((inputs?: Templates_Ai_Brief_LabelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Ai_Brief_LabelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_ai_brief_label(inputs)
	return cs_templates_ai_brief_label(inputs)
});